// Configuration déplacée dans un objet
const SHOP_CONFIG = {
  API_URL: "https://shiltonbtoc.myshopify.com/api/graphql",
  // À déplacer dans les variables d'environnement
  API_TOKEN: "bed5d13cb27809df5fff9fc133990ee9",
  FILE_URL: "https://cdn.shopify.com/s/files/1/2618/6980/files/",
};

// Requêtes GraphQL extraites
const GRAPHQL_QUERIES = {
  productsByTitle: (title) => `
    query {
      products(first:100, query: "title:'${title}'") {
        edges {
          node {
            id
            title
            productType
            handle
            onlineStoreUrl
            options {
              name
              values
            }
            metafield1: metafield(key:"color_image", namespace:"custom"){
              value
            }
            metafield2: metafield(key:"couleur", namespace:"custom"){
              value
            }
          }
        }
      }
    }`,

  productById: (id) => `
    query {
      product(id: "gid://shopify/Product/${id}") {
        id
        metafield(namespace: "custom", key: "color_image") {
          reference {
            ... on MediaImage {
              id
              image {
                originalSrc
              }
            }
          }
        }
      }
    }`,
};

function searchProductsByType(elem) {
  // On récupère le titre du produit
  let title = elem.data("product-title");
  // On récupère le type de produit
  let type = elem.data("product-type");

  // Si un type de produit est défini, on lance la recherche
  if (type != "") {
    /*
              metafield3: metafield(key:"couleur", namespace:"global"){
                value
              }
    */
    // On charge tous les produits du type
    $.ajax({
      url: SHOP_CONFIG.API_URL,
      method: "POST",
      headers: {
        "X-Shopify-Storefront-Access-Token": SHOP_CONFIG.API_TOKEN,
        "Content-Type": "application/graphql",
      },
      data: GRAPHQL_QUERIES.productsByTitle(title),
    }).done(function (data) {
      // Si aucun produit trouvé, on masque le bloc
      if (!data.data.products) {
        elem.remove();
      } else {
        // On retire les éléments existants
        elem.find(".color-selector a").remove();

        // On récupère le bloc sticky
        const stickyForm = $(".product-sticky-form");
        const colorSelector = elem.find(".color-selector");

        // On récupère les produits
        const edges = data.data.products.edges;

        // On parcourt les produits
        for (let i = 0; i < edges.length; i++) {
          const product = edges[i].node;
          const shopifyId = product.id;
          let id = shopifyId.split("/").pop();
          const title = product.title;
          const handle = product.handle;

          let mCouleur = "";
          let color_handle = "";

          // Si le produit correspond au produit actuel, on récupère les options
          if (title == elem.data("product-title")) {
            options = product.options;
            // On parcourt les options
            for (let j = 0; j < options.length; j++) {
              const name = String(options[j].name).toLowerCase();
              if (
                name == "coloris" ||
                name == "couleur" ||
                name == "couleurs"
              ) {
                color_handle = String(options[j].values[0])
                  .replace(/\s+/g, "_")
                  .toLowerCase(); //.slugify("_");
                break;
              }
            }

            // Si le produit existe, on récupère les métadonnées
            if (handle) {
              // On initialise les variables
              sHtmlMeta = sHtmlClass = mImage = mColoris = mCouleur = "";

              if (product.metafield1) mImage = product.metafield1.value;
              if (product.metafield2) mCouleur = product.metafield2.value;
              //if (product.metafield3) mColoris = product.metafield3.value;

              if (mImage != "") {
                // Si une image est définie, on ajoute la classe
                sHtmlClass = " load-color-image";
                sHtmlMeta = 'data-product-id="' + id + '"';
              } else if (mCouleur != "")
                // Si une couleur est définie, on ajoute la couleur
                sHtmlMeta = 'style="background-color:' + mCouleur + '"';
              else if (color_handle != "")
                // Si une couleur est définie, on ajoute la couleur
                sHtmlMeta =
                  'style="background-color:' +
                  (oProductSwatchColors[color_handle]
                    ? oProductSwatchColors[color_handle]
                    : "#ddd") +
                  '"';
              //else if (mColoris != '') sHtmlMeta = 'style="background-color:' + (oProductSwatchColors[mColoris] ? oProductSwatchColors[mColoris] : '#ddd') + '"';
              else sHtmlMeta = 'style="background-color:#ddd"';

              // On ajoute le sélecteur de couleur
              colorSelector.append(
                '<a href="/products/' +
                  handle +
                  '" data-aaa="' +
                  color_handle +
                  '" class="color-variant' +
                  sHtmlClass +
                  (handle == elem.data("product-handle") ? " active" : "") +
                  '" title="' +
                  title +
                  '" ' +
                  sHtmlMeta +
                  "></a>"
              );

              // Si le bloc sticky est présent, on ajoute le sélecteur de couleur
              if (
                stickyForm.length > 0 &&
                handle !== elem.data("product-handle")
              ) {
                stickyForm.find(".combo-box__option-list")?.append(
                  `<a href="/products/${handle}" role="option" class="combo-box__option-item" value="${color_handle}" aria-selected="false">
                  <span class="combo-box__color-swatch" aria-label="${color_handle}" ${sHtmlMeta}></span>
                  ${
                    color_handle.charAt(0).toUpperCase() + color_handle.slice(1)
                  }
                </a>
                `
                );
              }
            }
          }
        }

        // On charge les images
        elem
          .find(".color-selector .color-variant.load-color-image")
          .each(function (i) {
            getProductColorImageSrc($(this));
          });
        elem
          .find(".color-selector .color-variant.load-file-image")
          .each(function (i) {
            getProductFileImageSrc($(this));
          });

        // On affiche le bloc
        $('.color-swatches[data-product-type="' + type + '"]:not(.ready)').each(
          function () {
            $(this).html(elem.html());
            $(this).addClass("ready").show();
          }
        );
      }

      // On affiche le bloc
      elem.addClass("ready").show();
      // Si le bloc est dans un produit, on lance la recherche des produits
      if (elem.closest(".product-item").length > 0) loopSearchProductsByType();
    });
  } else {
    // Si le bloc n'est pas dans un produit, on affiche le bloc
    elem.addClass("ready").show();
    // Si le bloc est dans un produit, on lance la recherche des produits
    if (elem.closest(".product-item").length > 0) loopSearchProductsByType();
  }
}

function getProductColorImageSrc(elem) {
  let id = elem.data("product-id");
  //const decoded = atob(id);
  //const shopifyId = decoded.split("/").pop();
  //const cleanId =  parseInt(shopifyId);

  $.ajax({
    url: SHOP_CONFIG.API_URL,
    method: "POST",
    headers: {
      "X-Shopify-Storefront-Access-Token": SHOP_CONFIG.API_TOKEN,
      "Content-Type": "application/graphql",
    },
    data: GRAPHQL_QUERIES.productById(id),
  }).done(function (data) {
    if (data.data.product) {
      shopifyId = data.data.product.id;
      id = shopifyId.split("/").pop();
      src = data.data.product.metafield.reference.image.originalSrc;

      $(
        '.color-selector .color-variant.load-color-image[data-product-id="' +
          id +
          '"]'
      ).css({ "background-image": 'url("' + src + '")' });
    }
  });
}

function getProductFileImageSrc(elem) {
  const file = elem.data("product-file");
  $(
    '.color-selector .color-variant.load-file-image[data-product-file="' +
      file +
      '"]'
  ).css({
    "background-image": 'url("' + SHOP_CONFIG.FILE_URL + file + '.jpg")',
  });
}

function loopSearchProductsByType() {
  // On récupère le premier bloc non prêt
  let elem = $(".color-swatches:not(.ready):eq(0)");
  // Si un bloc existe, on lance la recherche
  if (elem.length > 0) searchProductsByType(elem);
}

if (typeof jQuery !== "undefined") {
  $(document).ready(function () {
    loopSearchProductsByType();
  });
} else {
  console.error("jQuery n'est pas chargé !");
}
